import { z } from 'zod';
export const insuranceClaimsTasksActionsCapability = 'tasks.project-action-summary.v1';
export const insuranceClaimsTasksActionsSlot = 'insurance-claims.project-actions';
export const insuranceClaimsTasksActionsProviderId = 'tasks.server.insurance-claims-actions';
const idSchema = z.string().uuid();
const countSchema = z.number().int().nonnegative();
export const insuranceClaimsTasksActionsProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(insuranceClaimsTasksActionsCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const insuranceClaimsTasksActionsProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(insuranceClaimsTasksActionsCapability),
    projectId: idSchema,
    totalCount: countSchema,
    actionRequiredCount: countSchema,
    byStatus: z.strictObject({
        open: countSchema,
        inProgress: countSchema,
        blocked: countSchema,
        done: countSchema,
        cancelled: countSchema,
    }),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    observedAt: z.string().datetime({ offset: true }).nullable(),
}).superRefine((value, context) => {
    const statusTotal = Object.values(value.byStatus).reduce((sum, count) => sum + count, 0);
    const required = value.byStatus.open + value.byStatus.inProgress + value.byStatus.blocked;
    if (statusTotal !== value.totalCount || required !== value.actionRequiredCount) {
        context.addIssue({ code: 'custom', message: 'Task action facts do not reconcile.' });
    }
});
export const insuranceClaimsTasksActionsUnavailableReasonSchema = z.enum([
    'not-installed',
    'not-enabled',
    'permission-denied',
    'provider-invalid',
    'provider-failed',
]);
export const insuranceClaimsTasksActionsAvailabilitySchema = z.discriminatedUnion('state', [
    insuranceClaimsTasksActionsProviderResponseSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(insuranceClaimsTasksActionsCapability),
        reasonCode: insuranceClaimsTasksActionsUnavailableReasonSchema,
    }),
]);
//# sourceMappingURL=insurance-claims-tasks-actions.contract.js.map